import { PolygonClippedGridSystem } from '@zwaarcontrast/ol-graticule';
import { ProjectedGridSystem, registerCRS, } from '@zwaarcontrast/ol-graticule-projected';
import { registerRDNAPTRANS2018 } from '../rdnaptrans.js';
/**
 * Shared implementation for `createRDNewGridSystem` / `createRDOldGridSystem`.
 * Registers the RDNAPTRANS 2018 grid and the CRS, constructs a no-clip
 * {@link ProjectedGridSystem} in the inner position, and wraps it with
 * {@link PolygonClippedGridSystem} so the NL area-of-use polygon is clipped
 * geometrically (no cell-staircase outline) and emitted as a first-class
 * boundary feature.
 */
export function createRDGridSystem(crs, proj4Def, extent, defaultClipPolygon, options) {
    registerRDNAPTRANS2018();
    registerCRS(crs, proj4Def);
    const { clipPolygon: clipOverride, ...projOptions } = options ?? {};
    const inner = new ProjectedGridSystem({
        ...projOptions,
        crs,
        extent,
    });
    return new PolygonClippedGridSystem({
        source: inner,
        clipPolygon: {
            rings: [clipOverride ?? defaultClipPolygon],
            crs,
        },
    });
}
//# sourceMappingURL=shared.js.map